export default __webpack_public_path__ + "static/media/circle6.aa78b475.png";